import { combineReducers } from 'redux';
import onboardingReducer from './onboardingReducer';

const rootReducer = combineReducers({
  onboarding: onboardingReducer,
  // Add other reducers here as needed
});

export default rootReducer;
